//@flow
import React, { type Node } from 'react';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { Box, Image, Letterbox, Mask, Text } from 'gestalt';

type PropType = {
  backgroundColor?: string,
  followersCount: ?number,
  followersCountDisplay: ?Node,
  image: ?{
    url: string,
    height: number,
    width: number,
  },
  name: string,
  width: number,
};

export default function Topic({
  backgroundColor,
  followersCount,
  followersCountDisplay,
  image,
  name,
  width,
}: PropType) {
  const templateString = i18n.ngettext(
    '{{ count }} {{ label }}',
    '{{ count }} {{ label }}',
    followersCount || 0,
    'indicate a number of followers',
  );
  const followerLabel = i18n.ngettext(
    'follower',
    'followers',
    followersCount || 0,
    'used in {{count}} {{followers}}',
  );

  return (
    <Box>
      <Mask shape="rounded">
        {image ? (
          <Box position="relative">
            <Letterbox width={width} height={width} contentAspectRatio={image.width / image.height}>
              <Image
                alt={name}
                color={backgroundColor}
                naturalHeight={1}
                naturalWidth={1}
                src={image.url}
              />
            </Letterbox>
            <Box
              height={width}
              width={width}
              dangerouslySetInlineStyle={{
                __style: {
                  backgroundImage: `linear-gradient(to bottom,
                  rgba(181, 181, 181, .1) 0%,
                  rgba(0, 0, 0, .2) 33%,
                  rgba(0, 0, 0, .5) 66%,
                  rgba(0, 0, 0, .7) 100%)`,
                },
              }}
              position="absolute"
              top
            />
          </Box>
        ) : (
          <Box
            height={width}
            width={width}
            dangerouslySetInlineStyle={{
              __style: {
                backgroundColor,
              },
            }}
          />
        )}
        <Box bottom left right position="absolute" padding={3}>
          <Text
            color="white"
            lgSize="lg"
            mdSize="md"
            overflow="normal"
            size="lg"
            smSize="sm"
            weight="bold"
          >
            {name}
          </Text>
          {followersCount ? (
            <Box>
              {interpolateNamedTemplate(templateString, {
                count: (
                  <Text color="white" inline key="followersCount" size="sm" weight="bold">
                    {followersCountDisplay}
                  </Text>
                ),
                label: (
                  <Text color="white" inline key="followersLabel" size="sm">
                    {followerLabel}
                  </Text>
                ),
              })}
            </Box>
          ) : null}
        </Box>
      </Mask>
    </Box>
  );
}

Topic.propTypes = {
  backgroundColor: PropTypes.string,
  followersCount: PropTypes.number,
  followersCountDisplay: PropTypes.node,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
  name: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
};
